import React from 'react';
import './scholarship.css';

const academicRows = [
  { grade: '95% & Above (Aggregate)', scholarship: '60% OFF' },
  { grade: '90% - 94.9%', scholarship: '50% OFF' },
  { grade: '85% - 89.9%', scholarship: '40% OFF' },
  { grade: '80% - 84.9%', scholarship: '30% OFF' },
  { grade: '75% - 79.9%', scholarship: '20% OFF' },
  { grade: 'Below 75%', scholarship: 'Up to 10% OFF (Support Scholarship)' },
];

const achievementRows = [
  { title: 'School/State Merit (Top performer / Awardee)', scholarship: 'Up to 50%' },
  { title: 'National Olympiad Level (Qualified / Merit List)', scholarship: 'Up to 60%' },
  { title: 'Top National Rankers (Rank holders)', scholarship: 'Up to 80%' },
  { title: 'International Achievers (Medal / Special Recognition)', scholarship: 'Up to 100%' },
];

const terms = [
  "Scholarships are applicable on the Tuition Fee component only. Admission fees, study material costs, and taxes are payable in full.",
  "Scholarships cannot be combined. If a student qualifies for multiple categories (e.g., SCAT score + Board Marks), only the highest percentage will be applied.",
  "Original documents (Mark sheets, Rank cards, Certificates) must be presented physically for verification at the center to avail merit-based scholarships.",
  "Management reserves the right to modify scholarship brackets without prior notice.",
];

const Scholarship: React.FC = () => {
  return (
    <div className="scholarship-page">
      <section className="scholarship-hero">
        <div className="hero-inner">
          <h1>S-CUBUS Scholarships</h1>
          <p>
            Rewarding Academic Merit & Competitive Excellence. We believe financial
            constraints shouldn't hinder true potential.
          </p>
        </div>
      </section>

      <main className="scholarship-content">
        <section className="policy-card">
          <div className="policy-icon">
            <span className="material-symbols-outlined">info</span>
          </div>
          <div>
            <h3>Important Scholarship Policy</h3>
            <p>
              A student can avail any <strong>ONE</strong> scholarship category, whichever is higher.
              We ensure you receive the maximum benefit applicable to your merit.
            </p>
          </div>
        </section>

        <section className="sat-card-wrap">
          {/* Left avatar/illustration (overlapping) */}
          <div className="sat-card__image">
            <img src="/mode/scholrship.png" alt="Scholarship Illustration" />
          </div>

          {/* Main SCAT card */}
          <div className="sat-card">
            <div className="sat-copy">
              <div className="pill">MOST POPULAR</div>
              <h2>S-CUBUS Admission Test (SCAT)</h2>
              <p>
                Our premier admission test allows students from Class 8th to 12th (+ 12 Pass)
                to prove their mettle. It is the most direct way to earn a massive fee waiver
                based on raw potential.
              </p>

              <div className="stat-grid">
                <div>
                  <p className="label">Eligibility</p>
                  <p className="value">Class 8th - 12th & 12 Pass</p>
                </div>
              </div>

              <button className="btn sat-btn">
                Register for SCAT
                <span className="material-symbols-outlined">arrow_forward</span>
              </button>
            </div>

            <div className="sat-highlight">
              <div className="badge">
                <span className="material-symbols-outlined">verified</span>
              </div>
              <p className="highlight-label">Scholarships</p>
              <h3>Up to 100%</h3>
              <p className="subtext">OFF on Tuition Fee</p>
              <div className="divider" />
              <p className="footnote">*Performance based. Terms & conditions apply.</p>
            </div>
          </div>
        </section>

        <section className="tables-grid">
          <div className="table-card">
            <div className="table-header">
              <div className="table-icon">
                <span className="material-symbols-outlined">analytics</span>
              </div>
              <h3>Academic Performance</h3>
            </div>

            <div className="table">
              <div className="table-row table-head">
                <span>Board Score / Grade</span>
                <span>Scholarship</span>
              </div>

              {academicRows.map((row) => (
                <div className="table-row" key={row.grade}>
                  <span>{row.grade}</span>
                  <span className="bold">{row.scholarship}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="table-card">
            <div className="table-header">
              <div className="table-icon orange">
                <span className="material-symbols-outlined">trophy</span>
              </div>
              <h3>Competitive Achievements</h3>
            </div>

            <div className="table">
              <div className="table-row table-head">
                <span>Achievement Category</span>
                <span>Scholarship</span>
              </div>

              {achievementRows.map((row) => (
                <div className="table-row" key={row.title}>
                  <span>{row.title}</span>
                  <span className="bold">{row.scholarship}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="terms-card">
          <div className="terms-head">
            <span className="material-symbols-outlined">gavel</span>
            <h4>Terms & Conditions</h4>
          </div>
          <ul>
            {terms.map((term) => (
              <li key={term}>{term}</li>
            ))}
          </ul>
        </section>

        <section className="cta-section">
          <div className="cta-copy">
            <h2>Ready to start your journey?</h2>
            <p>Because ambition deserves opportunity—start your journey to your dream college today.</p>
          </div>

          <div className="cta-actions">
            <a
              className="btn primary"
              href="https://forms.gle/xdExtHf2Yss4ZaHq9"
              target="_blank"
              rel="noopener noreferrer"
            >
              Register for Admission Test
            </a>
            <a className="btn alt cta-phone" href="tel:+9101146696001">
              <span className="material-symbols-outlined">call</span>
              <div className="cta-phone__content">
                <p className="cta-phone__label">Contact us</p>
                <strong className="cta-phone__number">01146696001</strong>
              </div>
            </a>
          </div>
        </section>
      </main>

    </div>
  );
};

export default Scholarship;
